/*==================================================

ページ内リンク
==================================================*/
jQuery(function(){
  var screenWidth = window.innerWidth;
  var headerHight = 0;//ヘッダの高さ
  if (screenWidth >= 1079) {
    headerHight = 85 + 16;
  }else if(screenWidth <= 1080 ) {
    headerHight = 60 + 16;
  }
  jQuery('a[href^="#"]').on("click", function (event) {
    event.preventDefault();
    var href = jQuery(this).attr("href");
    var target = jQuery(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
    jQuery("html, body").animate({ scrollTop: position }, 500, "swing");
    return false;
  });
});